

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { API_URL } from '../services/api';

// function OrderConfirmationPage() {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       const token = localStorage.getItem('access_token');
//       const urlParams = new URLSearchParams(window.location.search);
//       const orderIds = urlParams.get('order_ids');

//       if (!token) {
//         alert("You must be logged in to view the orders.");
//         return;
//       }

//       try {
//         if (orderIds) {
//           const orderIdsArray = orderIds.split(',');
//           const responses = await Promise.all(
//             orderIdsArray.map(orderId =>
//               axios.get(`${API_URL}api/orders/${orderId}/`, {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                 },
//               })
//             )
//           );
//           setOrders(responses.map(response => response.data));
//         } else {
//           const orderId = urlParams.get('order_id');
//           const response = await axios.get(`${API_URL}api/orders/${orderId}/`, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           });
//           setOrders([response.data]);
//         }
//       } catch (err) {
//         console.error('Error fetching orders:', err);
//         setError('Failed to load order details');
//       }
//     };

//     fetchOrders();
//   }, []);

//   if (error) {
//     return <div>{error}</div>;
//   }

//   if (!orders.length) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1>Order Confirmation</h1>
//       {orders.length > 1 ? (
//         <h2>{orders.length} Orders</h2>
//       ) : (
//         <h2>Order {orders[0].id}</h2>
//       )}

//       {orders.map((order) => {
//         const shippingAddress = order.shipping_address ? JSON.parse(order.shipping_address) : {};

//         return (
//           <div key={order.id}>
//             <p>Status: {order.status}</p>
//             <p>Total Price: ${order.total_price}</p>

//             {/* Show optional fields if available */}
//             {order.order_total_shipping_fees && (
//               <p>Shipping Fee: ${order.order_total_shipping_fees}</p>
//             )}
//             {order.tracking_number && (
//               <p>Tracking Number: {order.tracking_number}</p>
//             )}
//             {order.notes && (
//               <p>Notes: {order.notes}</p>
//             )}
//             {order.card_brand && (
//               <p>Card Brand: {order.card_brand}</p>
//             )}
//             {order.billing_address && (
//               <div>
//                 <h3>Billing Address:</h3>
//                 <p>{order.billing_address}</p>
//               </div>
//             )}

//             {/* Display Shipping Address */}
//             {shippingAddress && (
//               <div>
//                 <h3>Shipping Address:</h3>
//                 <p>Line 1: {shippingAddress.line1}</p>
//                 <p>Line 2: {shippingAddress.line2}</p>
//                 <p>City: {shippingAddress.city}</p>
//                 <p>State: {shippingAddress.state}</p>
//                 <p>Postal Code: {shippingAddress.postal_code}</p>
//                 <p>Country: {shippingAddress.country}</p>
//               </div>
//             )}

//             <h2>Order Items:</h2>
//             <ul>
//               {order.order_items.map((item) => (
//                 <li key={item.id}>
//                   <h3>{item.product_name}</h3>

//                   {item.variant_options && Object.keys(item.variant_options).length > 0 && (
//                     <p>
//                       Variant: {Object.entries(item.variant_options)
//                         .map(([key, value]) => `${key}: ${value}`)
//                         .join(', ')}
//                     </p>
//                   )}

//                   <p>Price: ${item.product_price}</p>
//                   <p>Quantity: {item.quantity}</p>
//                   <p>Total: ${item.total_price}</p>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// export default OrderConfirmationPage;
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../services/api';

function OrderConfirmationPage() {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      const token = localStorage.getItem('access_token');
      const urlParams = new URLSearchParams(window.location.search);
      const orderIds = urlParams.get('order_ids');

      if (!token) {
        alert("You must be logged in to view the orders.");
        return;
      }

      try {
        if (orderIds) {
          const orderIdsArray = orderIds.split(',');
          const responses = await Promise.all(
            orderIdsArray.map(orderId =>
              axios.get(`${API_URL}api/orders/${orderId}/`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
            )
          );
          setOrders(responses.map(response => response.data));
        } else {
          const orderId = urlParams.get('order_id');
          const response = await axios.get(`${API_URL}api/orders/${orderId}/`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setOrders([response.data]);
        }
      } catch (err) {
        console.error('Error fetching orders:', err);
        setError('Failed to load order details');
      }
    };

    fetchOrders();
  }, []);

  if (error) return <div>{error}</div>;
  if (!orders.length) return <div>Loading...</div>;

  return (
    <div className="order-confirmation" style={{ padding: '2rem' }}>
      <h1>Order Confirmation</h1>
      {orders.length > 1 ? (
        <h2>{orders.length} Orders</h2>
      ) : (
        <h2>Order #{orders[0].id}</h2>
      )}

      {orders.map((order) => {
        const shippingAddress = order.shipping_address ? JSON.parse(order.shipping_address) : {};

        return (
          <div key={order.id} style={{ marginBottom: '3rem', padding: '1.5rem', border: '1px solid #ccc', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '0.5rem' }}>Order #{order.id}</h3>
            <p><strong>Status:</strong> {order.status}</p>
            <p><strong>Total:</strong> ${order.total_price}</p>

            {order.order_total_shipping_fees && (
              <p><strong>Shipping Fee:</strong> ${order.order_total_shipping_fees}</p>
            )}
            {order.tracking_number && (
              <p><strong>Tracking Number:</strong> {order.tracking_number}</p>
            )}
            {order.notes && (
              <p><strong>Notes:</strong> {order.notes}</p>
            )}
            {order.card_brand && (
              <p><strong>Card Brand:</strong> {order.card_brand}</p>
            )}

            {order.billing_address && (
              <div style={{ marginTop: '1rem' }}>
                <h4>Billing Address:</h4>
                <p>{order.billing_address}</p>
              </div>
            )}

            {shippingAddress && (
              <div style={{ marginTop: '1rem' }}>
                <h4>Shipping Address:</h4>
                <p>{shippingAddress.line1}</p>
                {shippingAddress.line2 && <p>{shippingAddress.line2}</p>}
                <p>{shippingAddress.city}, {shippingAddress.state} {shippingAddress.postal_code}</p>
                <p>{shippingAddress.country}</p>
              </div>
            )}

            <div style={{ marginTop: '1.5rem' }}>
              <h4>Order Items:</h4>
              <ul style={{ paddingLeft: '1.25rem' }}>
                {order.order_items.map((item) => (
                  <li key={item.id} style={{ marginBottom: '1rem' }}>
                    <p><strong>{item.product_name}</strong></p>
                    {item.variant_options && Object.keys(item.variant_options).length > 0 && (
                      <p>
                        Variant:{" "}
                        {Object.entries(item.variant_options)
                          .map(([key, value]) => `${key}: ${value}`)
                          .join(", ")}
                      </p>
                    )}
                    <p>Price: ${item.product_price}</p>
                    <p>Quantity: {item.quantity}</p>
                    <p><strong>Total: ${item.total_price}</strong></p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default OrderConfirmationPage;
